import parseSubdomains from '../../../utils/parseSubdomains';

const isPkiChannel = () => {
  const subdomains = parseSubdomains(window.location.hostname);
  return subdomains.channel === 'pki';
};

export default isPkiChannel;
